window.ko.mapping = require('./vendor/knockout.mapping');

(function(window, $, ko) {

    /**
     * A computable property that can be added to viewModels to track dirty state
     */
    function DirtyTracker(objectToTrack, hashFunction) {
        hashFunction = hashFunction || ko.toJSON;
        var lastCleanState = ko.observable(hashFunction(objectToTrack));

        var result = {
            isDirty : ko.dependentObservable(function() {
                return hashFunction(objectToTrack) != lastCleanState()
            }),
            markClean : function() {
                lastCleanState(hashFunction(objectToTrack));
            }
        };

        return function() { return result }
    }


    /**
     * A custom binding that allows transitioning between elements
     */
    ko.bindingHandlers.slideVisible = {
        init: function(element, valueAccessor) {
            // Initially set the element to be instantly visible/hidden depending on the value
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
        },
        update: function(element, valueAccessor) {
            // Whenever the value subsequently changes, slowly fade the element in or out
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).slideDown() : $(element).slideUp();
        }
    };


    /**
     * A binding that allows us to stop binding for decendants
     */
    ko.bindingHandlers.stopBinding = {
      init: function() {
        return {
            controlsDescendantBindings: true
        };
      }
    };

    ko.virtualElements.allowedBindings.stopBinding = true;

    window.ko = ko;
    window.DirtyTracker = DirtyTracker;

})(window, jQuery, ko);
